<template>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-6">
            <StepsPercentage percentage="width:75%;" outerClass="mb-4" />

            <div class="card bg-white">
                <div class="card-body border-0">
                    <div class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">
                            In order to receive a loan you will need an active bank account
                        </div>
                    </div>
        
                    <form @submit.prevent="validateBeforeSubmit">
                        <fieldset class="mb-5">
                            <div v-if="!validationAttempt" class="form-group mb-0">
                                <div class="mt-3 mb-2 check-label">Do you have an active checking account?</div>                           
                                <div class="radio-options">
                                    <div class="radio-option" :class="bankAccountType == 'checking' ? 'selected' : ''" @click="oneClickSubmit('checking')">
                                        Yes
                                    </div>
                                    <div class="radio-option align-items-center" :class="bankAccountType == 'none' ? 'selected' : ''" @click="validationAttempt = true">
                                        No
                                    </div>
                                </div>
                            </div>
                            <div v-else class="form-group mb-0">
                                <div class="mt-3 mb-2 check-label">Do you have an active savings account?</div>                           
                                <div class="radio-options">
                                    <div class="radio-option" :class="bankAccountType == 'savings' ? 'selected' : ''" @click="oneClickSubmit('savings')">
                                        Yes
                                    </div>
                                    <div class="radio-option align-items-center" :class="bankAccountType == 'none' ? 'selected' : ''" @click="oneClickSubmit('none')">
                                        No
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div><!--End Card Body-->
            </div><!--End Card-->
        </div><!--End Col-->
    </div><!--End Row-->
</template>

<script>
import StepsPercentage from '@/components/form/StepsPercentage.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'WizardStep4',
    title: 'Apply | Step 4',
    components:{
        StepsPercentage
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,
            bankAccountType: '',
            
		}
    },
    methods: {
        ...mapActions(['saveFormData']),
        oneClickSubmit(value){
            this.bankAccountType = value;
            this.saveFormData({
                'bankAccountType': this.bankAccountType,
				'step4': true,
            });
            if(this.bankAccountType == 'none'){
                this.$router.push({ path: '/apply/4/declined' });
            } else {
                this.$router.push({ path: '/apply/5' });
            }
        },
    },
    computed: {
        ...mapGetters(["formData"]),
    },
    created(){
        this.bankAccountType = this.formData.bankAccountType || '';
  }
}
</script>

<style>
    
</style>
